import _ from 'underscore';
import { localizeSegmentationValue } from '@bingads-webui-campaign/segmentation-utilities';
import defaultTemplate from './segment-value-cell-default.pug';

function toggleAggregateSeg(e) {
  const name = this.$(e.target).closest('tr, .tr').attr('data-aggregate-name'); // eslint-disable-line no-invalid-this
  const segmentCur = this.get('segment'); // eslint-disable-line no-invalid-this
  const expandedAggregateCur = segmentCur.expandedAggregate;
  const expandedAggregate = _.contains(expandedAggregateCur, name) ?
    _.without(expandedAggregateCur, name) :
    _.union(expandedAggregateCur, [name]);

  this.set({
    segment: _.defaults({ expandedAggregate }, segmentCur),
  });
}

function isAggregateRow(row) {
  return !!(_.result(row.item, '$total', false) || _.result(row.item, 'AggregateName', false));
}

function translateSegRow(columnGroup, r, index, segmentCellStyleConfig, segmentConfig) {
  let row = _.extend({}, r);

  if (_.result(row.item, 'IsSegmentRow', false) || isAggregateRow(row)) {
    const patch = {};

    patch.cells = _.map(columnGroup.leafColumns, (col, colIndex) => {
      if (_.has(segmentCellStyleConfig.cellTemplates, col.name)) {
        let newHtml = null;
        const template = segmentCellStyleConfig.cellTemplates[col.name] === 'default' ?
          defaultTemplate :
          segmentCellStyleConfig.cellTemplates[col.name];

        if (isAggregateRow(row)) {
          const rowType = _.result(row.item, '$total', {}).type;
          const expanded = _.contains(segmentConfig.expandedAggregate, rowType ||
            row.item.AggregateName);

          const value = _.result(row.item, '$total', {}).text || row.item.AggregateName;

          newHtml = template({
            value,
            isAggregate: true,
            hasSegment: row.item.HasSegmentRow && !row.item.isTopAggregate,
            expanded,
            helpId: _.result(row.item, '$total', {}).helpId,
            helpAriaLabel: segmentCellStyleConfig.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: value }),
          });
        } else {
          newHtml = template({
            value: localizeSegmentationValue({
              i18n: segmentCellStyleConfig.i18n,
              type: row.item.SegmentationType,
              value: row.item.SegmentValue,
            }),
          });
        }
        return _.defaults({
          html: newHtml,
        }, row.cells[colIndex]);
      }

      return row.cells[colIndex];
    });

    if (_.result(row.item, 'IsSegmentRow', false)) {
      row.classes = row.classes.concat('segment-row');
    } else {
      row = _.defaults({
        attributes: _.defaults({
          'data-aggregate-name': _.result(row.item, '$total', {}).type || row.item.AggregateName,
        }, row.attributes),
      }, row);
    }

    return _.defaults(patch, row);
  }

  return row;
}

export default {
  name: 'segmentCellStyle',
  handler: function segmentCellStyle(state, segmentCellStyleConfig) {
    const { columnGroup } = state;
    const segmentConfig = this.get('segment'); // eslint-disable-line no-invalid-this

    const bodyRows = {
      length: state.bodyRows.length,
      slice: (begin = 0, end = state.bodyRows.length) => state.bodyRows.slice(begin, end)
        .map((row, index) => translateSegRow(
          columnGroup,
          row,
          index + begin,
          segmentCellStyleConfig,
          segmentConfig
        )),
    };

    const events = _.defaults({
      'click .aggregate-row td .glyphicon-triangle-right, .aggregate-row .td .glyphicon-triangle-right': toggleAggregateSeg,
      'click .aggregate-row td .glyphicon-triangle-bottom, .aggregate-row .td .glyphicon-triangle-bottom': toggleAggregateSeg,
      'click .aggregated-row td .glyphicon-triangle-right, .aggregated-row .td .glyphicon-triangle-right': toggleAggregateSeg,
      'click .aggregated-row td .glyphicon-triangle-bottom, .aggregated-row .td .glyphicon-triangle-bottom': toggleAggregateSeg,
    }, state.events);

    return _.defaults({
      bodyRows,
      events,
    }, state);
  },
  defaults: {},
};
